export const style = {
  wrapper: {
    marginBottom: `60px`
  },
  h2: {
    fontSize: `2.2rem`,
    fontWeight: 300,
    margin: `0 0 14px 0`,
    lineHeight: `42px`,
    letterSpacing: `-1px`
  },
  h2Rotator: {
    height: `42px`,
    overflow: `hidden`,
    textAlign: `left`,
    position: `relative`
  },
  h2InnetTitleWrapper: {
    position: `relative`,
    transition: `0.2s`
  },
  hide: {
    opacity: 0,
    transitionDelay: `0.2s`
  },
  h2InnerTitle: {
    display: `block`,
    fontWeight: 700,
    lineHeight: `42px`,
    color: `#A94545`
  },
  p: {
    marginBottom: `20px`,
    fontSize: `16px`,
    fontWeight: 300,
    lineHeight: `1.4`,
    color: `#666`,
    '@media (min-width: 768px)': {
      fontSize: `21px`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Home/style/welcome.js